import { defineComponent as d, useAttrs as u, inject as p, ref as f, computed as h, createElementBlock as k, createCommentVNode as i, openBlock as l, createElementVNode as m, createBlock as c, resolveDynamicComponent as g, toRaw as v, mergeProps as r, unref as o, renderSlot as w } from "vue";
import { sizeInjectionKey as S } from "../HorizontalSeriesBlock/HorizontalSeriesBlock.constant.js";
import { RevIllustration as y } from "@ds/components/Illustration";
import { tw as s } from "../../utils/tailwind.js";
const z = {
  key: 0,
  class: "min-h-48 w-160 shrink-0 list-none md:max-w-none md:flex-1"
}, B = { class: "flex h-full items-center md:w-full" }, j = /* @__PURE__ */ d({
  name: "RevHorizontalSeriesBlockItem",
  inheritAttrs: !1,
  __name: "HorizontalSeriesBlockItem",
  props: {
    icon: {},
    imageSrc: {}
  },
  setup(_) {
    const t = u(), n = p(S, f("large")), a = h(() => [
      s`mr-12 shrink-0 align-middle`,
      n.value === "small" && s`p-12`,
      n.value === "large" && s`p-0`
    ]);
    return (e, C) => e.icon || e.imageSrc ? (l(), k("li", z, [
      m("div", B, [
        e.icon ? (l(), c(g(v(e.icon)), r({ key: 0 }, o(t), {
          class: a.value,
          "data-test": "icon",
          size: "48"
        }), null, 16, ["class"])) : e.imageSrc ? (l(), c(o(y), r({
          key: 1,
          alt: ""
        }, o(t), {
          class: a.value,
          height: 48,
          role: "presentation",
          src: e.imageSrc,
          width: 48
        }), null, 16, ["class", "src"])) : i("", !0),
        m("span", r(o(t), { class: "body-2 inline-block overflow-hidden break-words text-left align-middle md:flex-1" }), [
          w(e.$slots, "default")
        ], 16)
      ])
    ])) : i("", !0);
  }
});
export {
  j as default
};
